//This is a workaround for now, we need to figure out a way to load directly to the Config.res file
const config = require('Config');
module.exports = config;
